import React, { useCallback, useEffect, useState } from 'react';
import CheckBoxIcon from '@mui/icons-material//CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material//CheckBoxOutlineBlank';
import { Autocomplete, Checkbox, TextField } from '@mui/material';
import { DocumentReferencesView } from 'api';
import { FILE_NAME } from 'common/constants/documents';
import { NotReferencedDocumentsListProps } from './NotReferencedDocumentsList.props';

const NotReferencedDocumentsList = ({
  documents,
  placeholder,
  referencedDocuments,
  setSelectedValues,
}: NotReferencedDocumentsListProps) => {
  const [filteredDocuments, setFilteredDocuments] = useState<DocumentReferencesView[]>([]);
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const handleChange = (_event: React.ChangeEvent<unknown>, data: DocumentReferencesView[]) => {
    setSelectedValues(data);
  };

  useEffect(() => {
    const filteredReferencedDocuments = documents.filter(
      document =>
        !referencedDocuments?.map(refDoc => refDoc.document_reference_id).includes(document.document_reference_id)
    );
    // Add selected attribute for each document in filteredReferencedDocuments
    const selectedDocuments = filteredReferencedDocuments.map(document => ({
      ...document,
    }));
    setFilteredDocuments(selectedDocuments);
  }, [documents, referencedDocuments]);

  const getFileName = useCallback((option: DocumentReferencesView) => {
    if (option.file) {
      return FILE_NAME(option);
    }
    return '';
  }, []);

  return (
    <div style={{ width: '100%' }}>
      {documents && (
        <Autocomplete
          multiple
          id="checkboxes-documents"
          options={filteredDocuments}
          disableCloseOnSelect
          onChange={handleChange}
          getOptionLabel={getFileName}
          renderOption={(props, option, { selected }) => (
            <li {...props} style={{ display: 'flex', alignItems: 'center' }}>
              <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} />
              {getFileName(option)}
            </li>
          )}
          renderInput={params => <TextField {...params} variant="outlined" placeholder={placeholder} />}
          style={{ width: '100%' }}
          getOptionSelected={(option, value) => option.document_reference_id === value.document_reference_id}
        />
      )}
    </div>
  );
};

export default NotReferencedDocumentsList;
